import { SelectOption } from '@frontend/components/basic-forms';
import { UserState, UserStateName } from '@frontend/user/types';
import { useMemo } from 'react';

import { UserStateSelectProps } from './user-state-select.component';

interface ViewProps {
    options: SelectOption<UserStateName>[];
}

const useUserStateSelect = (props: UserStateSelectProps): ViewProps => {
    const options = useMemo(
        () =>
            UserState.ALL.filter((state) => (props.subset ? props.subset.includes(state.value) : true)).map((state) => ({
                value: state.value,
                label: state.value,
                display: state.displayName
            })),
        [props.subset]
    );

    return { options };
};

export default useUserStateSelect;
